<template>
    <div class="wrap wrap--min wrap--last">
        <SectionTitle text="Category" class="title" />

        <!-- PC -->
        <ul class="category-pc">
            <li v-for="(item, index) in category" :key="item.name">
                <a :href="item.link" v-if="!item.sub">{{ item.name }}</a>
                <span v-else @click="toggleList(index)">
                    {{ item.name }}
                </span>

                <div class="sub-category-wrap-pc" v-if="item.sub">
                    <!-- PC用refに分離 -->
                    <ul class="sub-category-pc" ref="subCategoryPc">
                        <li v-for="i in item.sub" :key="i.name">
                            <a :href="i.link">{{ i.name }}</a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>

        <!-- SP -->
        <ul class="category-sp">
            <li v-for="(item, index) in category" :key="item.name">
                <a :href="item.link" v-if="!item.sub">{{ item.name }}</a>

                <span v-else @click="toggleList(index)">
                    {{ item.name }}

                    <span class="cross">
                        <span></span>
                        <transition name="fade">
                            <span v-show="!item.heightState"></span>
                        </transition>
                    </span>
                </span>

                <div class="sub-category-wrap-sp" v-if="item.sub" :style="{ height: item.heightState + 'px' }">
                    <!-- SP用refに分離 -->
                    <ul class="sub-category-sp" ref="subCategorySp">
                        <li v-for="i in item.sub" :key="i.name">
                            <a :href="i.link">{{ i.name }}</a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'

const SP_MAX_WIDTH = 722 // 既存のSP想定に合わせて調整してください

export default {
  name: 'Category',

  components: { SectionTitle },

  computed: {
    category () {
      const all = this.$store.state.json.category || {}
      return all[this.$store.state.hostName] || []
    }
  },

  methods: {
    updateIsSp () {
      this.isSp = window.matchMedia(`(max-width: ${SP_MAX_WIDTH}px)`).matches
    },

    setSubHeights () {
      // 表示対象のrefだけを見る（PC hidden 時の 0 を拾わない）
      const refs = this.isSp ? this.$refs.subCategorySp : this.$refs.subCategoryPc
      const list = Array.isArray(refs) ? refs : (refs ? [refs] : [])

      let counter = 0
      this.category.forEach((item) => {
        if (!item.sub) return

        const el = list[counter]
        // scrollHeight の方が安定（clientHeightが0になりやすいケースを回避）
        const h = el ? (el.scrollHeight || el.clientHeight || 0) : 0

        this.$set(item, 'subHeight', h)
        // 初期は閉じる想定なのでheightStateは0のまま（必要なら開いた状態にもできます）
        this.$set(item, 'heightState', item.heightState || 0)

        counter++
      })
    },

    recalc () {
      this.updateIsSp()
      this.$nextTick(() => {
        this.setSubHeights()
      })
    },

    toggleList (index) {
      const item = this.category[index]

      // 念のため、プロパティが無いケースにも安全に対応
      if (typeof item.heightState !== 'number') this.$set(item, 'heightState', 0)
      if (typeof item.subHeight !== 'number') this.$set(item, 'subHeight', 0)

      if (item.heightState) {
        item.heightState = 0
      } else {
        item.heightState = item.subHeight
      }
    },

    onResize () {
      this.recalc()
    }
  },

  mounted () {
    this.recalc()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="scss" scoped>
.category-pc {
    display: block;
    text-transform: uppercase;

    @media screen and (max-width: 722px) {
        display: none;
    }

    >li {

        >a,
        >span {
            font-size: 18px;
        }
    }

    >li+li {
        padding-top: 80px;
    }

}

.category-sp {
    display: none;
    text-transform: uppercase;

    @media screen and (max-width: 722px) {
        display: block;
    }

    >li {

        >a,
        >span {
            position: relative;
            display: block;
            padding: 12px 0;
        }
    }
}

$crossWidth: 11px;

.cross {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: $crossWidth;
    height: $crossWidth;
    margin: auto 0;
    display: block;

    span {
        position: absolute;
        display: block;
        background: #222222;

        &:nth-child(1) {
            top: $crossWidth/2 - 1px;
            left: 0;
            width: $crossWidth;
            height: 1px;
        }

        &:nth-child(2) {
            top: 0;
            left: $crossWidth/2 - 1px;
            width: 1px;
            height: $crossWidth;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.sub-category-wrap-pc {}

.sub-category-wrap-sp {
    overflow: hidden;
    transition: height .4s;
}

.sub-category-pc {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding-top: 20px;

    @media screen and (min-width: 723px) and (max-width: 963px) {
        grid-template-columns: repeat(2, 1fr);
    }
}

.sub-category-sp {
    >li {

        >a,
        span {
            display: block;
            padding: 10px 30px;
        }
    }
}
</style>
